import { createSelector } from 'reselect';

const stateOperaciones = (state) => state.operaciones;

export const selectOperaciones = createSelector(
  [stateOperaciones],
  (operacion) => operacion || {}
);